import { useState, useCallback } from 'react';
import { fmoInputService } from '../services/fmoInputService';

export function useFMOInputsData() {
  const [allFMOInputs, setAllFMOInputs] = useState([]); // Store all FMO inputs for tree building
  const [allFMOInputsLoading, setAllFMOInputsLoading] = useState(false);  // Loading state for all FMO inputs
  const [error, setError] = useState(null);
  
  // Fetch all FMO inputs with pagination (for tree building)
  const fetchAllFMOInputs = useCallback(async () => {
    setAllFMOInputsLoading(true);
    setError(null);
    
    try {
      const limit = 1000;
      let allItems = [];
      let offset = 0;
      let hasMore = true;
      let total = 0;
      
      // Keep fetching until we have all data
      while (hasMore) {
        const response = await fmoInputService.fetchAll({
          offset,
          limit
        });
        
        const items = response.items || [];
        allItems = [...allItems, ...items];
        
        // Check if there are more items to fetch
        total = response.total || response.count || 0;
        hasMore = allItems.length < total;
        offset += limit;
      }
      
      // Update state once with all data
      setAllFMOInputs(allItems);
      console.log(`Fetched all FMO inputs: ${allItems.length} total`);
      return allItems;
    } catch (err) {
      console.error('Failed to fetch all FMO inputs:', err);
      setError(err.message || 'Failed to load FMO inputs');
      setAllFMOInputs([]);
      return [];
    } finally {
      setAllFMOInputsLoading(false);
    }
  }, []);
  
  
  return {
    allFMOInputs,
    allFMOInputsLoading,  // Loading state for all FMO inputs (tree building)
    error,
    fetchAllFMOInputs
  };
}